module.exports = __webpack_public_path__ + "static/media/landing01.d41d8cd9.mp4";